<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="12">
            <a-form-item label="月份">
              <a-select placeholder="请选择" v-model="queryParam.month">
                <a-select-option value="01">1月</a-select-option>
                <a-select-option value="02">2月</a-select-option>
                <a-select-option value="03">3月</a-select-option>
                <a-select-option value="04">4月</a-select-option>
                <a-select-option value="05">5月</a-select-option>
                <a-select-option value="06">6月</a-select-option>
                <a-select-option value="07">7月</a-select-option>
                <a-select-option value="08">8月</a-select-option>
                <a-select-option value="09">9月</a-select-option>
                <a-select-option value="10">10月</a-select-option>
                <a-select-option value="11">11月</a-select-option>
                <a-select-option value="12">12月</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="10">
            <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;height:40px;">
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="itemSlot" slot-scope="item">
          <span v-if="item.level===1">{{item.text}}</span>
          <span v-if="item.level===2" style="margin-left:0px;">{{item.text}}</span>
          <span v-if="item.level===3" style="margin-left:45px;">{{item.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { toDecimal } from '@/utils/util'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  import {getDictItemsFromCache} from '@/api/api'

  export default {
    name: 'BizLifeReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '寿险报表', //所有机构人身险
        disableMixinCreated: true,
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目',
            className: 'column-text',
            scopedSlots: {customRender: 'itemSlot'}
          },
          {
            title:'德州',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A04Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A04Amount',
              }]
          },
          {
            title:'枣庄',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A07Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A07Amount',
              }]
          },
          {
            title:'临沂',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A12Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A12Amount',
              }]
          },
          {
            title:'淄博',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A03Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A03Amount',
              }]
          },
          {
            title:'青岛',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A13Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A13Amount',
              }]
          },
          {
            title:'滨城',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03A08A08Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03A08A08Amount',
              }]
          },
          {
            title:'总部',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'A03Premium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'A03Amount',
              }]
          },
          {
            title:'合计',
            children:[
              {
                title:'本年保费累计',
                className: 'column-money',
                dataIndex: 'HJPremium',
              },{
                title:'本年佣金累计',
                className: 'column-money',
                dataIndex: 'HJAmount',
              }]
          },
        ],
        url: {
          list: "/bms/regulatoryReport/lifeReport",
        },
      }
    },
    created() {
    },
    methods: {
      searchQuery(){
        if(this.queryParam.month){
          this.loadData()
        }
      },
      loadData() {
        this.loading = true;

        let year = new Date().getFullYear()
        let param = {year: year, month: this.queryParam.month}
        this.dataSource = this.transferData();
        /*以invoice_time字段进行比较，即财务开票日期归属到不同月份*/
        postAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        // 总部寿险数据，顺序是确定的, level是报表中的级次，显示用
        let lifeData = [
          {text:'一、寿险小计',level:1, insuranceTypeCode:'SXXJ', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,HJPremium:0.00,HJAmount:0.00},
          {text:'（一）普通寿险',level:2, insuranceTypeCode:'PTSX', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'1、定期寿险',level:3, insuranceTypeCode:'33', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'2、两全寿险',level:3, insuranceTypeCode:'34', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'3、终身寿险',level:3, insuranceTypeCode:'35', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'4、年金保险',level:3, insuranceTypeCode:'36', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'（二）分红寿险',level:2, insuranceTypeCode:'FHSX', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'1、定期寿险',level:3, insuranceTypeCode:'37', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'2、两全寿险',level:3, insuranceTypeCode:'38', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'3、终身寿险',level:3, insuranceTypeCode:'39', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'4、年金保险',level:3, insuranceTypeCode:'40', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'（三）投资连结产品',level:2, insuranceTypeCode:'24', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'其中：年金保险',level:3, insuranceTypeCode:'41', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'（四）万能寿险',level:2, insuranceTypeCode:'25', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'其中：年金保险',level:3, insuranceTypeCode:'42', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'二、意外伤害险小计',level:1, insuranceTypeCode:'YWSH', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'1、一年期以内业务',level:3, insuranceTypeCode:'26', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'2、一年期业务',level:3, insuranceTypeCode:'27', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'3、一年期以上业务',level:3, insuranceTypeCode:'28', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'三、健康险小计',level:1, insuranceTypeCode:'JKX', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'1、短期健康险',level:3, insuranceTypeCode:'29', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'2、长期健康险',level:3, insuranceTypeCode:'30', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'四、其他',level:1, insuranceTypeCode:'23', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00},
          {text:'总计',level:1, insuranceTypeCode:'ZJ', A03Premium:0.00, A03Amount:0.00,A03A08A03Premium:0.00,
            A03A08A03Amount:0.00,A03A08A12Premium:0.00, A03A08A12Amount:0.00,A03A08A13Premium:0.00, A03A08A13Amount:0.00,
            A03A08A04Amount:0.00,A03A08A04Premium:0.00,
            A03A08A07Amount:0.00,A03A08A07Premium:0.00,
            A03A08A08Amount:0.00,A03A08A08Premium:0.00,
            HJPremium:0.00,HJAmount:0.00}];

        // 赋值结果集, 一次赋值各组织机构
        for(let i=0; i<resultData.length; i++){
          let money = resultData[i];
          for(let j=0; j<lifeData.length; j++){
            if(lifeData[j].insuranceTypeCode == money.insuranceTypeCode){
              lifeData[j][money.orgCode+'Premium'] = money.cleanPremium
              lifeData[j][money.orgCode+'Amount'] = money.invoiceAmount
              break; //退出内层循环
            }
          }
        }

        //计算求和, 根据报表公司直接求和

        //处理两个特殊编码 投连年金 万能年金, 分组织机构, 作为公式计算 编码：24=24+41 对应行次12=12+13
        lifeData[11].A03Premium = lifeData[11].A03Premium + lifeData[12].A03Premium
        lifeData[11].A03Amount = lifeData[11].A03Amount + lifeData[12].A03Amount
        lifeData[11].A03A08A03Premium = lifeData[11].A03A08A03Premium + lifeData[12].A03A08A03Premium
        lifeData[11].A03A08A03Amount = lifeData[11].A03A08A03Amount + lifeData[12].A03A08A03Amount
        lifeData[11].A03A08A12Premium = lifeData[11].A03A08A12Premium + lifeData[12].A03A08A12Premium
        lifeData[11].A03A08A12Amount = lifeData[11].A03A08A12Amount + lifeData[12].A03A08A12Amount
        lifeData[11].A03A08A13Premium = lifeData[11].A03A08A13Premium + lifeData[12].A03A08A13Premium
        lifeData[11].A03A08A13Amount = lifeData[11].A03A08A13Amount + lifeData[12].A03A08A13Amount

        lifeData[11].A03A08A04Premium = lifeData[11].A03A08A04Premium + lifeData[12].A03A08A04Premium
        lifeData[11].A03A08A04Amount  = lifeData[11].A03A08A04Amount  + lifeData[12].A03A08A04Amount
        lifeData[11].A03A08A07Premium = lifeData[11].A03A08A07Premium + lifeData[12].A03A08A07Premium
        lifeData[11].A03A08A07Amount = lifeData[11].A03A08A07Amount + lifeData[12].A03A08A07Amount
        lifeData[11].A03A08A08Premium = lifeData[11].A03A08A08Premium + lifeData[12].A03A08A08Premium
        lifeData[11].A03A08A08Amount = lifeData[11].A03A08A08Amount + lifeData[12].A03A08A08Amount

        //万能寿险年金, 行次公式14=14+15
        lifeData[13].A03Premium = lifeData[13].A03Premium + lifeData[14].A03Premium
        lifeData[13].A03Amount = lifeData[13].A03Amount + lifeData[14].A03Amount
        lifeData[13].A03A08A03Premium = lifeData[13].A03A08A03Premium + lifeData[14].A03A08A03Premium
        lifeData[13].A03A08A03Amount = lifeData[13].A03A08A03Amount + lifeData[14].A03A08A03Amount
        lifeData[13].A03A08A12Premium = lifeData[13].A03A08A12Premium + lifeData[14].A03A08A12Premium
        lifeData[13].A03A08A12Amount = lifeData[13].A03A08A12Amount + lifeData[14].A03A08A12Amount
        lifeData[13].A03A08A13Premium = lifeData[13].A03A08A13Premium + lifeData[14].A03A08A13Premium
        lifeData[13].A03A08A13Amount = lifeData[13].A03A08A13Amount + lifeData[14].A03A08A13Amount

        lifeData[13].A03A08A04Premium = lifeData[13].A03A08A04Premium + lifeData[14].A03A08A04Premium
        lifeData[13].A03A08A04Amount  = lifeData[13].A03A08A04Amount  + lifeData[14].A03A08A04Amount
        lifeData[13].A03A08A07Premium = lifeData[13].A03A08A07Premium + lifeData[14].A03A08A07Premium
        lifeData[13].A03A08A07Amount = lifeData[13].A03A08A07Amount + lifeData[14].A03A08A07Amount
        lifeData[13].A03A08A08Premium = lifeData[13].A03A08A08Premium + lifeData[14].A03A08A08Premium
        lifeData[13].A03A08A08Amount = lifeData[13].A03A08A08Amount + lifeData[14].A03A08A08Amount

        //2＝3+4+5+6
        lifeData[1].A03Premium = lifeData[2].A03Premium + lifeData[3].A03Premium + lifeData[4].A03Premium + lifeData[5].A03Premium
        lifeData[1].A03Amount = lifeData[2].A03Amount + lifeData[3].A03Amount + lifeData[4].A03Amount + lifeData[5].A03Amount
        lifeData[1].A03A08A03Premium = lifeData[2].A03A08A03Premium + lifeData[3].A03A08A03Premium + lifeData[4].A03A08A03Premium + lifeData[5].A03A08A03Premium
        lifeData[1].A03A08A03Amount = lifeData[2].A03A08A03Amount + lifeData[3].A03A08A03Amount + lifeData[4].A03A08A03Amount + lifeData[5].A03A08A03Amount
        lifeData[1].A03A08A12Premium = lifeData[2].A03A08A12Premium + lifeData[3].A03A08A12Premium + lifeData[4].A03A08A12Premium + lifeData[5].A03A08A12Premium
        lifeData[1].A03A08A12Amount = lifeData[2].A03A08A12Amount + lifeData[3].A03A08A12Amount + lifeData[4].A03A08A12Amount + lifeData[5].A03A08A12Amount
        lifeData[1].A03A08A13Premium = lifeData[2].A03A08A13Premium + lifeData[3].A03A08A13Premium + lifeData[4].A03A08A13Premium + lifeData[5].A03A08A13Premium
        lifeData[1].A03A08A13Amount = lifeData[2].A03A08A13Amount + lifeData[3].A03A08A13Amount + lifeData[4].A03A08A13Amount + lifeData[5].A03A08A13Amount
        lifeData[1].A03A08A04Premium = lifeData[2].A03A08A04Premium + lifeData[3].A03A08A04Premium + lifeData[4].A03A08A04Premium + lifeData[5].A03A08A04Premium
        lifeData[1].A03A08A04Amount  = lifeData[2].A03A08A04Amount  + lifeData[3].A03A08A04Amount  + lifeData[4].A03A08A04Amount  + lifeData[5].A03A08A04Amount
        lifeData[1].A03A08A07Premium = lifeData[2].A03A08A07Premium + lifeData[3].A03A08A07Premium + lifeData[4].A03A08A07Premium + lifeData[5].A03A08A07Premium
        lifeData[1].A03A08A07Amount  = lifeData[2].A03A08A07Amount  + lifeData[3].A03A08A07Amount  + lifeData[4].A03A08A07Amount  + lifeData[5].A03A08A07Amount
        lifeData[1].A03A08A08Premium = lifeData[2].A03A08A08Premium + lifeData[3].A03A08A08Premium + lifeData[4].A03A08A08Premium + lifeData[5].A03A08A08Premium
        lifeData[1].A03A08A08Amount  = lifeData[2].A03A08A08Amount  + lifeData[3].A03A08A08Amount  + lifeData[4].A03A08A08Amount  + lifeData[5].A03A08A08Amount


        //7＝8+9+10+11
        lifeData[6].A03Premium = lifeData[7].A03Premium + lifeData[8].A03Premium + lifeData[9].A03Premium + lifeData[10].A03Premium
        lifeData[6].A03Amount = lifeData[7].A03Amount + lifeData[8].A03Amount + lifeData[9].A03Amount + lifeData[10].A03Amount
        lifeData[6].A03A08A03Premium = lifeData[7].A03A08A03Premium + lifeData[8].A03A08A03Premium + lifeData[9].A03A08A03Premium + lifeData[10].A03A08A03Premium
        lifeData[6].A03A08A03Amount = lifeData[7].A03A08A03Amount + lifeData[8].A03A08A03Amount + lifeData[9].A03A08A03Amount + lifeData[10].A03A08A03Amount
        lifeData[6].A03A08A12Premium = lifeData[7].A03A08A12Premium + lifeData[8].A03A08A12Premium + lifeData[9].A03A08A12Premium + lifeData[10].A03A08A12Premium
        lifeData[6].A03A08A12Amount = lifeData[7].A03A08A12Amount + lifeData[8].A03A08A12Amount + lifeData[9].A03A08A12Amount + lifeData[10].A03A08A12Amount
        lifeData[6].A03A08A13Premium = lifeData[7].A03A08A13Premium + lifeData[8].A03A08A13Premium + lifeData[9].A03A08A13Premium + lifeData[10].A03A08A13Premium
        lifeData[6].A03A08A13Amount = lifeData[7].A03A08A13Amount + lifeData[8].A03A08A13Amount + lifeData[9].A03A08A13Amount + lifeData[10].A03A08A13Amount
        lifeData[6].A03A08A04Premium = lifeData[7].A03A08A04Premium + lifeData[8].A03A08A04Premium + lifeData[9].A03A08A04Premium + lifeData[10].A03A08A04Premium
        lifeData[6].A03A08A04Amount  = lifeData[7].A03A08A04Amount  + lifeData[8].A03A08A04Amount  + lifeData[9].A03A08A04Amount  + lifeData[10].A03A08A04Amount
        lifeData[6].A03A08A07Premium = lifeData[7].A03A08A07Premium + lifeData[8].A03A08A07Premium + lifeData[9].A03A08A07Premium + lifeData[10].A03A08A07Premium
        lifeData[6].A03A08A07Amount  = lifeData[7].A03A08A07Amount  + lifeData[8].A03A08A07Amount  + lifeData[9].A03A08A07Amount  + lifeData[10].A03A08A07Amount
        lifeData[6].A03A08A08Premium = lifeData[7].A03A08A08Premium + lifeData[8].A03A08A08Premium + lifeData[9].A03A08A08Premium + lifeData[10].A03A08A08Premium
        lifeData[6].A03A08A08Amount  = lifeData[7].A03A08A08Amount  + lifeData[8].A03A08A08Amount  + lifeData[9].A03A08A08Amount  + lifeData[10].A03A08A08Amount

        //1＝2+7+12+14
        lifeData[0].A03Premium = lifeData[1].A03Premium + lifeData[6].A03Premium + lifeData[11].A03Premium + lifeData[13].A03Premium
        lifeData[0].A03Amount = lifeData[1].A03Amount + lifeData[6].A03Amount + lifeData[11].A03Amount + lifeData[13].A03Amount
        lifeData[0].A03A08A03Premium = lifeData[1].A03A08A03Premium + lifeData[6].A03A08A03Premium + lifeData[11].A03A08A03Premium + lifeData[13].A03A08A03Premium
        lifeData[0].A03A08A03Amount = lifeData[1].A03A08A03Amount + lifeData[6].A03A08A03Amount + lifeData[11].A03A08A03Amount + lifeData[13].A03A08A03Amount
        lifeData[0].A03A08A12Premium = lifeData[1].A03A08A12Premium + lifeData[6].A03A08A12Premium + lifeData[11].A03A08A12Premium + lifeData[13].A03A08A12Premium
        lifeData[0].A03A08A12Amount = lifeData[1].A03A08A12Amount + lifeData[6].A03A08A12Amount + lifeData[11].A03A08A12Amount + lifeData[13].A03A08A12Amount
        lifeData[0].A03A08A13Premium = lifeData[1].A03A08A13Premium + lifeData[6].A03A08A13Premium + lifeData[11].A03A08A13Premium + lifeData[13].A03A08A13Premium
        lifeData[0].A03A08A13Amount = lifeData[1].A03A08A13Amount + lifeData[6].A03A08A13Amount + lifeData[11].A03A08A13Amount + lifeData[13].A03A08A13Amount
        lifeData[0].A03A08A04Premium = lifeData[1].A03A08A04Premium + lifeData[6].A03A08A04Premium + lifeData[11].A03A08A04Premium + lifeData[13].A03A08A04Premium
        lifeData[0].A03A08A04Amount  = lifeData[1].A03A08A04Amount  + lifeData[6].A03A08A04Amount  + lifeData[11].A03A08A04Amount  + lifeData[13].A03A08A04Amount
        lifeData[0].A03A08A07Premium = lifeData[1].A03A08A07Premium + lifeData[6].A03A08A07Premium + lifeData[11].A03A08A07Premium + lifeData[13].A03A08A07Premium
        lifeData[0].A03A08A07Amount  = lifeData[1].A03A08A07Amount  + lifeData[6].A03A08A07Amount  + lifeData[11].A03A08A07Amount  + lifeData[13].A03A08A07Amount
        lifeData[0].A03A08A08Premium = lifeData[1].A03A08A08Premium + lifeData[6].A03A08A08Premium + lifeData[11].A03A08A08Premium + lifeData[13].A03A08A08Premium
        lifeData[0].A03A08A08Amount  = lifeData[1].A03A08A08Amount  + lifeData[6].A03A08A08Amount  + lifeData[11].A03A08A08Amount  + lifeData[13].A03A08A08Amount

        //16＝17+18+19
        lifeData[15].A03Premium = lifeData[16].A03Premium + lifeData[17].A03Premium + lifeData[18].A03Premium
        lifeData[15].A03Amount = lifeData[16].A03Amount + lifeData[17].A03Amount + lifeData[18].A03Amount
        lifeData[15].A03A08A03Premium = lifeData[16].A03A08A03Premium + lifeData[17].A03A08A03Premium + lifeData[18].A03A08A03Premium
        lifeData[15].A03A08A03Amount = lifeData[16].A03A08A03Amount + lifeData[17].A03A08A03Amount + lifeData[18].A03A08A03Amount
        lifeData[15].A03A08A12Premium = lifeData[16].A03A08A12Premium + lifeData[17].A03A08A12Premium + lifeData[18].A03A08A12Premium
        lifeData[15].A03A08A12Amount = lifeData[16].A03A08A12Amount + lifeData[17].A03A08A12Amount + lifeData[18].A03A08A12Amount
        lifeData[15].A03A08A13Premium = lifeData[16].A03A08A13Premium + lifeData[17].A03A08A13Premium + lifeData[18].A03A08A13Premium
        lifeData[15].A03A08A13Amount = lifeData[16].A03A08A13Amount + lifeData[17].A03A08A13Amount + lifeData[18].A03A08A13Amount
        lifeData[15].A03A08A04Premium = lifeData[16].A03A08A04Premium + lifeData[17].A03A08A04Premium + lifeData[18].A03A08A04Premium
        lifeData[15].A03A08A04Amount  = lifeData[16].A03A08A04Amount  + lifeData[17].A03A08A04Amount  + lifeData[18].A03A08A04Amount
        lifeData[15].A03A08A07Premium = lifeData[16].A03A08A07Premium + lifeData[17].A03A08A07Premium + lifeData[18].A03A08A07Premium
        lifeData[15].A03A08A07Amount  = lifeData[16].A03A08A07Amount  + lifeData[17].A03A08A07Amount  + lifeData[18].A03A08A07Amount
        lifeData[15].A03A08A08Premium = lifeData[16].A03A08A08Premium + lifeData[17].A03A08A08Premium + lifeData[18].A03A08A08Premium
        lifeData[15].A03A08A08Amount  = lifeData[16].A03A08A08Amount  + lifeData[17].A03A08A08Amount  + lifeData[18].A03A08A08Amount

        //20＝21+22
        lifeData[19].A03Premium = lifeData[20].A03Premium + lifeData[21].A03Premium
        lifeData[19].A03Amount = lifeData[20].A03Amount + lifeData[21].A03Amount
        lifeData[19].A03A08A03Premium = lifeData[20].A03A08A03Premium + lifeData[21].A03A08A03Premium
        lifeData[19].A03A08A03Amount = lifeData[20].A03A08A03Amount + lifeData[21].A03A08A03Amount
        lifeData[19].A03A08A12Premium = lifeData[20].A03A08A12Premium + lifeData[21].A03A08A12Premium
        lifeData[19].A03A08A12Amount = lifeData[20].A03A08A12Amount + lifeData[21].A03A08A12Amount
        lifeData[19].A03A08A13Premium = lifeData[20].A03A08A13Premium + lifeData[21].A03A08A13Premium
        lifeData[19].A03A08A13Amount = lifeData[20].A03A08A13Amount + lifeData[21].A03A08A13Amount
        lifeData[19].A03A08A04Premium = lifeData[20].A03A08A04Premium + lifeData[21].A03A08A04Premium
        lifeData[19].A03A08A04Amount  = lifeData[20].A03A08A04Amount  + lifeData[21].A03A08A04Amount
        lifeData[19].A03A08A07Premium = lifeData[20].A03A08A07Premium + lifeData[21].A03A08A07Premium
        lifeData[19].A03A08A07Amount  = lifeData[20].A03A08A07Amount  + lifeData[21].A03A08A07Amount
        lifeData[19].A03A08A08Premium = lifeData[20].A03A08A08Premium + lifeData[21].A03A08A08Premium
        lifeData[19].A03A08A08Amount  = lifeData[20].A03A08A08Amount  + lifeData[21].A03A08A08Amount

        //24＝1+16+20+23
        lifeData[23].A03Premium = lifeData[0].A03Premium + lifeData[15].A03Premium + lifeData[19].A03Premium + lifeData[22].A03Premium
        lifeData[23].A03Amount = lifeData[0].A03Amount + lifeData[15].A03Amount + lifeData[19].A03Amount + lifeData[22].A03Amount
        lifeData[23].A03A08A03Premium = lifeData[0].A03A08A03Premium + lifeData[15].A03A08A03Premium + lifeData[19].A03A08A03Premium + lifeData[22].A03A08A03Premium
        lifeData[23].A03A08A03Amount = lifeData[0].A03A08A03Amount + lifeData[15].A03A08A03Amount + lifeData[19].A03A08A03Amount + lifeData[22].A03A08A03Amount
        lifeData[23].A03A08A12Premium = lifeData[0].A03A08A12Premium + lifeData[15].A03A08A12Premium + lifeData[19].A03A08A12Premium + lifeData[22].A03A08A12Premium
        lifeData[23].A03A08A12Amount = lifeData[0].A03A08A12Amount + lifeData[15].A03A08A12Amount + lifeData[19].A03A08A12Amount + lifeData[22].A03A08A12Amount
        lifeData[23].A03A08A13Premium = lifeData[0].A03A08A13Premium + lifeData[15].A03A08A13Premium + lifeData[19].A03A08A13Premium + lifeData[22].A03A08A13Premium
        lifeData[23].A03A08A13Amount = lifeData[0].A03A08A13Amount + lifeData[15].A03A08A13Amount + lifeData[19].A03A08A13Amount + lifeData[22].A03A08A13Amount
        lifeData[23].A03A08A04Premium = lifeData[0].A03A08A04Premium + lifeData[15].A03A08A04Premium + lifeData[19].A03A08A04Premium + lifeData[22].A03A08A04Premium
        lifeData[23].A03A08A04Amount  = lifeData[0].A03A08A04Amount  + lifeData[15].A03A08A04Amount  + lifeData[19].A03A08A04Amount  + lifeData[22].A03A08A04Amount
        lifeData[23].A03A08A07Premium = lifeData[0].A03A08A07Premium + lifeData[15].A03A08A07Premium + lifeData[19].A03A08A07Premium + lifeData[22].A03A08A07Premium
        lifeData[23].A03A08A07Amount  = lifeData[0].A03A08A07Amount  + lifeData[15].A03A08A07Amount  + lifeData[19].A03A08A07Amount  + lifeData[22].A03A08A07Amount
        lifeData[23].A03A08A08Premium = lifeData[0].A03A08A08Premium + lifeData[15].A03A08A08Premium + lifeData[19].A03A08A08Premium + lifeData[22].A03A08A08Premium
        lifeData[23].A03A08A08Amount  = lifeData[0].A03A08A08Amount  + lifeData[15].A03A08A08Amount  + lifeData[19].A03A08A08Amount  + lifeData[22].A03A08A08Amount

        // 计算合计数
        for(let i=0; i<24; i++){
          lifeData[i].HJPremium = lifeData[i].A03Premium + lifeData[i].A03A08A03Premium + lifeData[i].A03A08A12Premium
            + lifeData[i].A03A08A13Premium + lifeData[i].A03A08A04Premium + lifeData[i].A03A08A07Premium + lifeData[i].A03A08A08Premium
          lifeData[i].HJAmount = lifeData[i].A03Amount + lifeData[i].A03A08A03Amount + lifeData[i].A03A08A12Amount
            + lifeData[i].A03A08A13Amount + lifeData[i].A03A08A04Amount + lifeData[i].A03A08A07Amount + lifeData[i].A03A08A08Amount
        }

        // 保留2位小数
        for(let i=0; i<lifeData.length; i++){
          lifeData[i].A03Premium =  toDecimal(lifeData[i].A03Premium)
          lifeData[i].A03Amount =  toDecimal(lifeData[i].A03Amount)
          lifeData[i].A03A08A03Premium =  toDecimal(lifeData[i].A03A08A03Premium)
          lifeData[i].A03A08A03Amount =  toDecimal(lifeData[i].A03A08A03Amount)
          lifeData[i].A03A08A12Premium =  toDecimal(lifeData[i].A03A08A12Premium)
          lifeData[i].A03A08A12Amount =  toDecimal(lifeData[i].A03A08A12Amount)
          lifeData[i].A03A08A13Premium =  toDecimal(lifeData[i].A03A08A13Premium)
          lifeData[i].A03A08A13Amount =  toDecimal(lifeData[i].A03A08A13Amount)
          lifeData[i].A03A08A04Premium =  toDecimal(lifeData[i].A03A08A04Premium)
          lifeData[i].A03A08A04Amount =  toDecimal(lifeData[i].A03A08A04Amount)
          lifeData[i].A03A08A07Premium =  toDecimal(lifeData[i].A03A08A07Premium)
          lifeData[i].A03A08A07Amount =  toDecimal(lifeData[i].A03A08A07Amount)
          lifeData[i].A03A08A08Premium =  toDecimal(lifeData[i].A03A08A08Premium)
          lifeData[i].A03A08A08Amount =  toDecimal(lifeData[i].A03A08A08Amount)

          lifeData[i].HJPremium = toDecimal(lifeData[i].HJPremium)
          lifeData[i].HJAmount = toDecimal(lifeData[i].HJAmount)
        }

        return lifeData;
      },

      getMoney(resultData, code){
        for(let i=0; i<resultData.length; i++){
          if(resultData[i].insuranceTypeCode == code){
            return resultData[i];
          }
        }
        //没有找到返回null
        return null;
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>
